<template>
  <div class="uc-alert uc-alert-examSubmitSure result camera_box">
    <div class="over-close"></div>
    <div class="box">
      <div class="con">
        <div class="title" v-if="title">{{ title }}</div>
        <div class="camera_wrap"><div id="my_camera"></div></div>
      </div>
      <div class="operate">
        <button @click="take_snapshot" class="uc-btn blue">点击拍照</button>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import Webcam from 'webcamjs';

export default Vue.extend({
  name: 'TakePhoto',
  props: {
    title: {
      type: String,
    },
  },
  data() {
    return {
      options: {
        width: 320,
        height: 240,
        image_format: 'jpeg',
        jpeg_quality: 90,
      },
    };
  },
  methods: {
    take_snapshot() {
      const vm = this;
      // take snapshot and get image data
      Webcam.snap((dataURL) => {
        vm.$emit('snap', vm.$utils.dataURLtoFile(dataURL));
      });
    },
  },
  mounted() {
    Webcam.set(this.options);
    Webcam.on('error', () => {
      this.$message({
        type: 'warning',
        message: '请先启用摄像头',
      });
    });
    Webcam.attach('#my_camera');
  },
});
</script>
